import { render } from "./AddConcept.vue?vue&type=template&id=13732260"
import script from "./AddConcept.vue?vue&type=script&lang=js"
export * from "./AddConcept.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__